var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-main-box",class:[{ 'hidden': !_vm.value, 'show': _vm.value },{ 'fixed': _vm.fixed }, _vm.theme]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"tip-close",on:{"click":_vm.close}},[_c('i',{staticClass:"el-icon-close"})]),_vm._v(" "),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb5f6e0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stories/messageTip/index.vue
// module id = null
// module chunks = 